export function documentationLinks(origin) {
    if (!origin) {
        return {
            application: 'https://quartile-one.gitlab.io/projects/gpc/cloudy-documentation/docs/intro',
            port: 'https://stacpdocportuserdocs.z8.web.core.windows.net/docs/intro',
            terminal: 'https://quartile-one.gitlab.io/simulation/projects/gpc/510762-terminal-capacity-model/',
        };
    }
    const url = new URL(origin);
    if (url.protocol !== 'https:' || url.username || url.password || url.pathname !== '/' || url.search || url.hash) {
        throw new Error('DOCUMENTATION_ORIGIN must be an HTTPS origin without credentials, path, query or fragment');
    }
    return {
        application: `${url.origin}/application/docs/intro/`,
        port: `${url.origin}/port/docs/intro/`,
        terminal: `${url.origin}/terminal/docs/intro/`,
    };
}
